import { defaultDialogSetupBuilder } from '@/components/services/dialog/dialogSetup';

export default (invokeArgs = {}) => {
  const dialogSubject = 'Subscription';

  defaultDialogSetupBuilder(
    {
      isModalShown: true,
      confirmTitle: `Cancel ${dialogSubject}`,
      confirmText: `Are you sure you want to cancel ${dialogSubject}? This action cannot be undone.`,
      confirmBtnColor: 'statusCanceled',
      confirmBtnText: `Cancel ${dialogSubject}`,
      ...invokeArgs,
    },
  );
};
